export type Period = "today" | "yesterday" | "7d" | "30d" | "year" | "custom";
export type Granularity = "hour" | "day" | "month";
export type CustomRange = { from: Date; to: Date };

export type DateRange = {
  after: string;
  before: string;
  prevAfter: string;
  prevBefore: string;
  days: number;
};

const DAY = 24 * 60 * 60 * 1000;

export function customGranularity(range: CustomRange): Granularity {
  const from = startOfDay(range.from);
  const to = startOfDay(range.to);
  const days = Math.round((to.getTime() - from.getTime()) / DAY) + 1;
  if (days <= 1) return "hour";
  if (days <= 92) return "day";
  return "month";
}

function startOfDay(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function getDateRange(period: Period, custom?: CustomRange | null, now = new Date()): DateRange {
  const startOfToday = startOfDay(now);

  let after: Date;
  let before: Date;
  let prevAfter: Date;
  let prevBefore: Date;

  switch (period) {
    case "today":
      after = startOfToday;
      before = now;
      prevAfter = new Date(after.getTime() - DAY);
      prevBefore = new Date(before.getTime() - DAY);
      break;
    case "yesterday":
      after = new Date(startOfToday.getTime() - DAY);
      before = startOfToday;
      prevAfter = new Date(after.getTime() - DAY);
      prevBefore = new Date(before.getTime() - DAY);
      break;
    case "7d":
      after = new Date(now.getTime() - 7 * DAY);
      before = now;
      prevAfter = new Date(after.getTime() - 7 * DAY);
      prevBefore = after;
      break;
    case "30d":
      after = new Date(now.getTime() - 30 * DAY);
      before = now;
      prevAfter = new Date(after.getTime() - 30 * DAY);
      prevBefore = after;
      break;
    case "year":
      after = new Date(now.getFullYear(), 0, 1);
      before = now;
      prevAfter = new Date(now.getFullYear() - 1, 0, 1);
      prevBefore = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes());
      break;
    case "custom": {
      if (!custom) throw new Error("customRange je obavezan za period 'custom'");
      after = startOfDay(custom.from);
      const endOfTo = new Date(startOfDay(custom.to).getTime() + DAY - 1);
      before = endOfTo.getTime() > now.getTime() ? now : endOfTo;
      const span = before.getTime() - after.getTime();
      prevBefore = after;
      prevAfter = new Date(after.getTime() - span);
      break;
    }
  }

  return {
    after: after.toISOString(),
    before: before.toISOString(),
    prevAfter: prevAfter.toISOString(),
    prevBefore: prevBefore.toISOString(),
    days: Math.max(1, (before.getTime() - after.getTime()) / DAY),
  };
}
